import { styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';
import withRouter from '../../../withRouter';
import WdNavBadge from '../../WdNavBadge';
import WdSvgIcon from '../../../WdSvgIcon';

const StyledListItem = styled(ListItem)(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none!important',
  minHeight: 48,
  '&.active': {
    backgroundColor: `${theme.palette.secondary.main}!important`,
    color: `${theme.palette.secondary.contrastText}!important`,
    pointerEvents: 'none',
    '& .Wd-list-item-text-primary': {
      color: 'inherit',
    },
    '& .Wd-list-item-icon': {
      color: 'inherit',
    },
  },
  '& .Wd-list-item-icon': {},
  '& .Wd-list-item-text': {
    padding: '0 0 0 16px',
  },
}));

function WdNavHorizontalLink(props) {
  const { item } = props;

  return useMemo(
    () => (
      <StyledListItem
        button
        component="a"
        href={item.url}
        target={item.target ? item.target : '_blank'}
        className={clsx('Wd-list-item')}
        role="button"
        sx={item.sx}
        disabled={item.disabled}
      >
        {item.icon && (
          <WdSvgIcon
            className={clsx('Wd-list-item-icon shrink-0', item.iconClass)}
            color="action"
          >
            {item.icon}
          </WdSvgIcon>
        )}

        <ListItemText
          className="Wd-list-item-text"
          primary={item.title}
          classes={{ primary: 'text-13 Wd-list-item-text-primary truncate' }}
        />

        {item.badge && <WdNavBadge className="ltr:ml-8 rtl:mr-8" badge={item.badge} />}
      </StyledListItem>
    ),
    [item.badge, item.icon, item.iconClass, item.target, item.title, item.url]
  );
}

WdNavHorizontalLink.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.string,
  }),
};

WdNavHorizontalLink.defaultProps = {};

const NavHorizontalLink = withRouter(memo(WdNavHorizontalLink));

export default NavHorizontalLink;
